export class TransferredSosFilterDto {
    createdFromDate:any;
    createdToDate:any
    endCustomer:number
    bapUnit:number;
    destination:number;
    processingUnit:number

}